exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/two-factors-authentication-component/two-factors-authentication.component.css
// module id = ./src/app/two-factors-authentication-component/two-factors-authentication.component.css
// module chunks = main